module.exports = __webpack_public_path__ + "img/nabl_gallery4.94969cd3.jpg";